import { useMemo } from "react";

import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableCellLink from "ds/components/Table/Row/CellLink";

import useCellCopyAction from "../useCellCopyAction";
import { showIntentProjectResourceDetailsDrawer } from "../../Details";
import IntentProjectResourcesTableGroupCell from "../GroupCell";
import { IntentResourceRow } from "../tableDataSelectors";

const IntentProjectResourcesTableIdCell = ({
  item: resource,
  ...cellProps
}: TableSimpleCellProps<IntentResourceRow>) => {
  const copyAction = useCellCopyAction({
    text: resource.resourceID,
  });

  const handlePress = () => {
    showIntentProjectResourceDetailsDrawer({ resource });
  };

  const actions = useMemo(() => [copyAction], [copyAction]);

  return (
    <IntentProjectResourcesTableGroupCell
      {...cellProps}
      role="rowheader"
      actions={actions}
      isGroup={resource.isGroup}
      groupId={resource.resourceID}
      intentProjectId={resource.intentProjectID}
    >
      <TableCellLink onPress={handlePress}>{resource.resourceID}</TableCellLink>
    </IntentProjectResourcesTableGroupCell>
  );
};

export default IntentProjectResourcesTableIdCell;
